export default __webpack_public_path__ + "static/media/LessonSelection.f7a98bf7.svg";